
import React from 'react';
import { motion } from 'framer-motion';

const ContactDataSection = () => {
  return (
    <div className="bg-white rounded-lg p-8 mb-12 shadow-xl">
      <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">
        How To Get Dream Client Contact Data For 1/50th The Price Of "Big Data"
      </h2>
      
      <div className="mb-8">
        <motion.img
          src="/lovable-uploads/2887d3f6-3850-4991-8156-1b1d22a18872.png"
          alt="Client contact data dashboard showing lead information"
          className="w-full rounded-lg shadow-md"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        />
      </div>
    </div>
  );
};

export default ContactDataSection;
